import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { SAVE_COMMAND } from './SavePlugin';

export const useSave = <T extends any[]>(
  fn: (markdown: string, ...args: T) => Promise<void>,
) => {
  const [editor] = useLexicalComposerContext();

  return useCallback(
    async (...args: T) => {
      const saveCallback = async (markdown: string) => {
        await fn(markdown, ...args);
      };
      editor.dispatchCommand(SAVE_COMMAND, saveCallback);
    },
    [editor, fn],
  );
};
